module.exports = __webpack_public_path__ + "img/license.653d611b.webp";